<template>
  <div class="base">
    <inside-header title="消息(3)" />
    <div class="main">
      <div class="list">
        <div v-for="(count, key) in 5" :key="key" class="item">
          <div class="header-img">
            <img src="@/assets/test-header.png" alt="">
          </div>
          <div class="info">
            <div class="name">
              <span>萧十一郎</span>
            </div>
            <div class="content">
              <span>你好，你离这边近吗？</span>
            </div>
          </div>
          <div class="time-num">
            <div class="time">
              下午3.44
            </div>
            <div class="num">
              <van-badge :content="200" max="99" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainFooter, InsideHeader } from '@/components'

export default {
  name: 'TutorPay',
  components: {
    MainFooter,
    InsideHeader
  },
  data() {
    return {
    }
  },
  created() {
    // this.loadData(this.id, this.$route.query)
  },
  methods: {
    // this.loadData(this.id, this.$route.query)
  }
}
</script>
<style lang="stylus" scoped>
  .base {
    min-width: 280px;
    max-width: 420px;
    margin: auto;
    background-color: #fff;
  }

  .main {
    padding: 15px;

    .list {
      .item {
        overflow: hidden;
        padding: 10px 0;
        border-bottom: 1px solid #eee;

        .header-img {
          float: left;

          img {
            width: 46px;
            height: 46px;
            border-radius: 50%;
          }
        }

        .info {
          width: 60%;
          float: left;
          margin-left: 10px;

          .name {
            span {
              font-family: PingFang-SC-Medium;
              font-size: 16px;
              color: #333333;
            }
          }

          .content {
            font-family: PingFang-SC-Medium;
            font-size: 12px;
            line-height: 12px;
            color: #999999;
          }
        }

        .time-num {
          float: right;

          .time {
            font-family: PingFang-SC-Medium;
            font-size: 11px;
            line-height: 12px;
            color: #999999;
          }

          .num {
            margin-top: 5px;
          }
        }
      }
    }
  }
</style>
